import { apiClient } from './api'

export interface LoginCredentials {
  email: string
  password: string
}

export interface SignUpData {
  full_name: string
  email: string
  password: string
  account_type: 'individual' | 'organization'
  organization_name?: string
  organization_description?: string
  selectedPlans?: Array<{
    service_name: 'BLIS' | 'IZG'
    plan_tier: string
    billing_cycle: 'monthly' | 'annual'
  }>
  selectedPaymentGateway?: 'stripe' | 'moyasar' | 'sadad'
}

export interface AuthResponse {
  user: {
    user_id: string
    email: string
    full_name: string
    is_active: boolean
    email_verified: boolean
    organization_id?: string
  }
  tokens: {
    access_token: string
    refresh_token: string
    token_type: string
    expires_in: number
  }
}

export const authService = {
  login: async (credentials: LoginCredentials): Promise<AuthResponse> => {
    const response = await apiClient.post<AuthResponse>('/auth/login', credentials)
    return response.data
  },


  logout: async (): Promise<void> => {
    await apiClient.post('/auth/logout')
  },

  refreshToken: async (refreshToken: string): Promise<{
    access_token: string
    refresh_token: string
    token_type: string
    expires_in: number
  }> => {
    const response = await apiClient.post<{
      access_token: string
      refresh_token: string
      token_type: string
      expires_in: number
    }>('/auth/refresh', {
      refresh_token: refreshToken,
    })
    return response.data
  },

  verifyEmail: async (token: string): Promise<void> => {
    await apiClient.post('/auth/verify-email', { token })
  },

  forgotPassword: async (email: string): Promise<void> => {
    await apiClient.post('/auth/forgot-password', { email })
  },

  resetPassword: async (token: string, new_password: string): Promise<void> => {
    await apiClient.post('/auth/reset-password', { token, new_password })
  },

  // Get current user info
  getCurrentUser: async (): Promise<{
    user_id: string
    email: string
    full_name: string
    is_active: boolean
    email_verified: boolean
    organization_id?: string
  }> => {
    const response = await apiClient.get<AuthResponse['user']>('/auth/me')
    return response.data
  },
}

